<script setup lang="ts">
import type { PromptSuggestion } from '@/lib/prompt-suggestions';

defineProps<{ items: PromptSuggestion[] }>();
const emit = defineEmits<{ (e: 'pick', s: PromptSuggestion): void }>();
</script>

<template>
  <div class="chips">
    <button
      v-for="s in items"
      :key="s.label"
      type="button"
      class="chips__chip"
      data-test="prompt-chip"
      @click="emit('pick', s)"
    >
      {{ s.label }}
    </button>
  </div>
</template>

<style scoped>
.chips {
  display: flex;
  gap: var(--sp-2);
  overflow-x: auto;
  scrollbar-width: none;
  padding-bottom: 2px;
  margin-top: 4px;
}
.chips::-webkit-scrollbar { display: none; }
.chips__chip {
  flex: 0 0 auto;
  padding: 6px 12px;
  border-radius: 999px;
  background: var(--bg-elevated);
  color: var(--text-secondary);
  font-size: var(--fs-sm);
  font-weight: 500;
  border: 1px solid var(--hairline);
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.12s ease, background 0.18s ease, color 0.18s ease;
}
.chips__chip:active {
  transform: scale(0.96);
  background: var(--accent-soft);
  color: var(--accent);
}
</style>
